import Papa from 'papaparse';

export const exportTableToCsv = ({
  display,
  headers,
  data,
}: {
  display: string;
  headers: string[];
  data: (string | number | null)[][];
}) => {
  // Convert the data to CSV format
  const csv = Papa.unparse({
    fields: headers,
    data,
  });

  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  link.setAttribute('download', `${display}.csv`);
  const url = URL.createObjectURL(blob);
  link.href = url;
  document.body.appendChild(link);

  // Add an event listener to revoke the object URL after the download is triggered
  link.addEventListener('click', () => {
    // Ensure that we revoke the URL after a delay to make sure download has initiated
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  });

  link.click();
  document.body.removeChild(link);
};
